export default {
	html: `
		<form id="inputs-export-csv-form" class="form" autocomplete="off">
			<p class="fss">Gera um arquivo CSV com os mesmos cabeçalhos da listagem
				(uma linha por entrada; separador ponto e vírgula, UTF-8).</p>
			<div class="fsb mtm">
				<label class="fss" style="display:flex;align-items:center;gap:0.5rem;cursor:pointer;">
					<input type="checkbox" id="use_list_filter" value="1" checked
						onchange="(function(c){var h=document.getElementById('export-csv-hint-bare-inputs');if(h)h.style.display=c.checked?'none':'block';})(this)">
					Aplicar os filtros e a ordenação <strong>atuais</strong> da tela
				</label>
			</div>
			<p class="fss" id="export-csv-hint-bare-inputs" style="display:none">
				<strong>Atenção:</strong> sem filtro, todas as entradas a que você tem acesso serão
				incluídas. Arquivos muito grandes podem demorar.
			</p>
			<div class="fsb mtm">
				<button type="button" class="bn_Escape button">Cancelar</button>
				<button type="submit" class="bn_Enter button">Exportar CSV</button>
			</div>
		</form>
	`,
	form: {
		selector: '#inputs-export-csv-form',
	},
	fields: [
		{ properties: { selector: '#use_list_filter' }, types: [] },
	],
};
